import React from "react";
import PanelCards from "containers/ControlPanel/CpCards";

const ControlPanel = props => {
  return <PanelCards history={props.history} />;
};

export default ControlPanel;
